<app-public-reports-layout>
  <mat-drawer-container autosize
                        class="full-height">
    <mat-drawer-content>
      <ng-container [ngSwitch]="reportType$ | async">
        <app-ad-reports class="full-height"
                        [publicReportData]="publicReportData$ | async"
                        *ngSwitchCase="'performance'"></app-ad-reports>
        <app-ad-reports class="full-height"
                        [publicReportData]="publicReportData$ | async"
                        *ngSwitchCase="'cycle'"></app-ad-reports>
        <app-dashboard-report class="full-height"
                              [publicReportData]="publicReportData$ | async"
                              *ngSwitchCase="'dashboard'"></app-dashboard-report>
        <app-chart-report class="full-height"
                          [publicReportData]="publicReportData$ | async"
                          *ngSwitchCase="'chart'"></app-chart-report>
        <app-channel-affinity-report class="full-height"
                                     [publicReportData]="publicReportData$ | async"
                                     *ngSwitchCase="'affinity'"></app-channel-affinity-report>
        <app-transaction-id-report class="full-height"
                                   [publicReportData]="publicReportData$ | async"
                                   *ngSwitchCase="'transaction-id'"></app-transaction-id-report>
        <app-path-explorer-report class="full-height"
                                  [publicReportData]="publicReportData$ | async"
                                  *ngSwitchCase="'path-explorer'"></app-path-explorer-report>
      </ng-container>
    </mat-drawer-content>
    <mat-drawer mode="side"
                position="end"
                [opened]="drawerIsOpened$ | async"
                (openedChange)="onDrawerOpenedChange()">
      <div id="information-container">
        <div class="display-flex flex-column full-height">
          <section>
            <div class="display-flex flex-align-center mb-1-rem">
              <div class="display-flex flex-align-center flex-grow overflow-hidden">
                <mat-icon class="mr-0-5rem material-icons-outlined">info</mat-icon>
                <h1 class="fs-1-7em text-ellipsis">
                  <ng-container *ngIf="reportIsLoaded$ | async; else reportNotLoaded">
                    {{ reportName$ | async }}
                  </ng-container>
                  <ng-template #reportNotLoaded>
                    ...
                  </ng-template>
                </h1>
              </div>
              <div class="display-inline-flex">
                <mat-icon class="icon-clickable"
                          [matTooltip]="'Hide report information'"
                          (click)="onCloseDrawer()">clear</mat-icon>
              </div>
            </div>
            <ng-container *ngIf="reportInformationIsLoaded$ | async; else loader">
              <div class="mb-1-rem">
                <div class="label">Created by</div>
                <div>{{ createdBy$ | async }}</div>
              </div>
              <div class="mb-1-rem">
                <div class="label">Site</div>
                <div>{{ datasetName$ | async }}</div>
              </div>
              <div>
                <div class="label">Space</div>
                <div>{{ spaceName$ | async }}</div>
              </div>
            </ng-container>
          </section>
          <section class="flex-grow">
            <div class="display-flex flex-column full-height">
              <div class="display-flex flex-align-center mb-1-rem">
                <mat-icon class="mr-0-5rem material-icons-outlined">settings</mat-icon>
                <h2>Report settings</h2>
              </div>
              <div class="flex-grow overflow-hidden relative">
                <div id="settings-container"
                     class="adloop-scrollbar"
                     *ngIf="reportSettingsIsLoaded$ | async; else loader">
                  <div class="mb-1-rem" *ngIf="(reportDimensions$ | async)?.length">
                    <div class="label">Dimensions</div>
                    <app-source class="display-block mt-0-3rem"
                                [item]="dimension.payload"
                                [enableHelpText]="true"
                                [enableCategory]="true"
                                *ngFor="let dimension of reportDimensions$ | async"></app-source>
                  </div>
                  <div class="mb-1-rem" *ngIf="(reportMetrics$ | async)?.length">
                    <div class="label">Metrics</div>
                    <app-source class="display-block mt-0-3rem"
                                [item]="metric.payload"
                                [enableHelpText]="true"
                                [enableCategory]="true"
                                *ngFor="let metric of reportMetrics$ | async"></app-source>
                  </div>
                  <div class="mb-1-rem" *ngIf="reportConversionMetric$ | async">
                    <div class="label">Conversion metric</div>
                    <app-source class="display-block mt-0-3rem"
                                [item]="(reportConversionMetric$ | async).payload"
                                [enableCategory]="true"
                                [enableHelpText]="true"></app-source>
                  </div>
                  <div class="mb-1-rem" *ngIf="reportChannel$ | async">
                    <div class="label">Channel</div>
                    <div>{{ (reportChannel$ | async).attributes.name }}</div>
                  </div>
                  <div>
                    <div class="display-flex flex-align-center">
                      <div class="label mr-0-5rem">Period</div>
                      <mat-icon class="icon-clickable icon-1-4-rem" matTooltip="Change dates" (click)="onOpenPeriodSetting()">settings</mat-icon>
                    </div>
                    <app-datepicker-period [period]="reportPeriod$ | async"
                                           [compare]="(reportPeriod$ | async)?.compareWith"></app-datepicker-period>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="display-flex justify-content-end section-actions">
            <app-button buttonType="mat-raised-button"
                        icon="close"
                        (click)="onCloseDrawer()">Hide report information</app-button>
          </section>
        </div>
      </div>
    </mat-drawer>
  </mat-drawer-container>
</app-public-reports-layout>
<ng-template #loader>
  <div class="display-flex justify-content">
    <mat-spinner diameter="25"></mat-spinner>
  </div>
</ng-template>
